export default __webpack_public_path__ + "static/media/remove.e19de971.svg";